import React, { Component } from "react";
import axios from "axios";
import { serverLink } from "../../../../resources/url";
import swal from "sweetalert";
import SubcategoryForm from "./subcategoryform";
import { accessControl } from "../../../../permission/permission";

class SubCategoryManagement extends Component {
  constructor() {
    super();
    accessControl([1, 4]);
    this.state = {
      isLoading: false,
      subcategories: [],
      editingSubcategory: null,
      categoryList: [],
      formData: {
        categoryName: "",
        subcategoryName: "",
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    this.setState({ isLoading: true });
    try {
      const [categoriesRes, subcategoriesRes] = await Promise.all([
        axios.get(`${serverLink}gallery/category/list`),
        axios.get(`${serverLink}gallery/subcategory/list`),
      ]);

      this.setState({
        categoryList: categoriesRes.data,
        subcategories: subcategoriesRes.data,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    const { editingSubcategory, formData } = this.state;

    if (!formData.categoryName || !formData.subcategoryName) {
      this.showAlert("Validation Error", "Please select category and enter subcategory name", "error");
      this.setState({ isLoading: false });
      return;
    }

    try {
      const endpoint = editingSubcategory
        ? `${serverLink}gallery/subcategory/update`
        : `${serverLink}gallery/subcategory/add`;

      const method = editingSubcategory ? "patch" : "post";
      const { data } = await axios[method](endpoint, formData);

      if (data.message === "success") {
        this.showAlert("Success", `Subcategory ${editingSubcategory ? "updated" : "added"} successfully`, "success");
        this.resetForm();
        this.fetchData();
      } else {
        this.showAlert("Error", data.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      this.showAlert("Error", "An error occurred", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleEdit = (subcategory) => {
    this.setState({
      editingSubcategory: subcategory,
      formData: {
        EntryID:subcategory.EntryID,
        categoryName: subcategory.CategoryName,
        subcategoryName: subcategory.SubCategoryName,
      },
    });
  };

  handleDelete = async (subcategoryId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the subcategory!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    try {
      this.setState({ isLoading: true });
      const { data } = await axios.delete(`${serverLink}gallery/subcategory/delete/${subcategoryId}`);

      if (data.message === "deleted") {
        this.showAlert("Deleted!", "Subcategory has been deleted.", "success");
        this.fetchData();
      } else {
        this.showAlert("Error", "Failed to delete subcategory", "error");
      }
    } catch (error) {
      console.error("Delete error:", error);
      this.showAlert("Error", "Failed to delete subcategory", "error");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  resetForm = () => {
    this.setState({
      editingSubcategory: null,
      formData: {
        categoryName: "",
        subcategoryName: "",
      },
    });
  };

  onEdit = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  showAlert(title, msg, type) {
    return swal({
      title,
      text: msg,
      icon: type,
      button: "OK",
    });
  }

  render() {
    const { subcategories, isLoading, formData, editingSubcategory, categoryList } = this.state;

    return (
      <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div className="toolbar" id="kt_toolbar">
          <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
            <div className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                About
                <span className="h-20px border-dark border-start ms-3 mx-2" />
                GALLERY
                <span className="h-20px border-dark border-start ms-3 mx-2" />
                {editingSubcategory ? "EDIT" : "ADD"} SUB-CATEGORY
              </h1>
            </div>
          </div>
        </div>

        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-fluid">
            <div className="card mb-5 mb-xl-10">
              <div className="card-header">
                <div className="card-title">
                  <h3>MANAGE SUB-CATEGORIES</h3>
                </div>
              </div>

              <SubcategoryForm
                handleSubmit={this.handleSubmit}
                onEdit={this.onEdit}
                isLoading={isLoading}
                data={formData}
                categoryList={categoryList}
                isEditing={!!editingSubcategory}
                onCancel={this.resetForm}
              />

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Subcategory</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading && !subcategories.length ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : subcategories.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No subcategories found
                          </td>
                        </tr>
                      ) : (
                        subcategories.map((subcat) => (
                          <tr key={subcat._id}>
                            <td>{subcat.CategoryName}</td>
                            <td>{subcat.SubCategoryName}</td>
                            <td>
                              <button className="btn btn-sm btn-primary me-2" onClick={() => this.handleEdit(subcat)}>
                                Edit
                              </button>
                              <button className="btn btn-sm btn-danger" onClick={() => this.handleDelete(subcat.EntryID)}>
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubCategoryManagement;
